var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_mobile_logout",
    "data-name": "Icon mobile logout",
    d: "M-7752.534-1783a.517.517,0,0,1-.533-.5.517.517,0,0,1,.533-.5h7.467v-14h-7.467a.517.517,0,0,1-.533-.5.517.517,0,0,1,.533-.5h8a.518.518,0,0,1,.534.5v15a.518.518,0,0,1-.534.5Zm-3.577-4.146-3.733-3.5A.485.485,0,0,1-7760-1791h0v-.012s0-.007,0-.011h0a.477.477,0,0,1,.018-.106,0,0,0,0,0,0,0,.059.059,0,0,0,0-.009l0,0a.029.029,0,0,1,0-.006l0-.008v0a.5.5,0,0,1,.127-.193l3.733-3.5a.56.56,0,0,1,.754,0,.478.478,0,0,1,0,.707l-2.823,2.647h9.913a.517.517,0,0,1,.534.5.518.518,0,0,1-.534.5h-9.912l2.822,2.647a.478.478,0,0,1,0,.707.55.55,0,0,1-.377.146A.553.553,0,0,1-7756.111-1787.146Z",
    transform: "translate(7760 1799)",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/Icon_Logout.720788dddafdf22fe6fdd86aac248ec2.svg";
export { ForwardRef as ReactComponent };